import * as Yup from "yup";

export const roleSchema = Yup.object().shape({
  name: Yup.string().required("O nome é obrigatório"),
  permissions: Yup.array()
    .of(Yup.string().required("Permissões obrigatórias"))
    .min(1, "Selecione pelo menos uma permissão"),
  description: Yup.string(),
});
